import { FC, ReactNode, useState, useCallback } from 'react';
import { Content, Root } from './styled';
import AccordionHeaderTitle from '../AccordionHeaderTitle';

type Props = {
  children?: ReactNode;
  titleId: string;
  value?: string;
};

const AccordionHeaderItem: FC<Props> = ({ children, titleId }) => {
  // State
  const [editActive, setActive] = useState<boolean>(true);

  // Open / close accordion
  const onClick = useCallback(
    (editActive: boolean) => {
      editActive = !editActive;
      setActive(!editActive);
    },
    [setActive]
  );
  return (
    <Root>
      <div>
        <AccordionHeaderTitle
          titleId={titleId}
          active={editActive}
          setActive={onClick}
        ></AccordionHeaderTitle>
        {editActive && <Content>{children}</Content>}
      </div>
    </Root>
  );
};

export default AccordionHeaderItem;
